export default function getTranslation (obj, language, fallback) {
  return obj[language] ? obj[language] : obj[fallback]
}